module.exports = __webpack_public_path__ + "img/5_106.c37e10ce.png";